import React from "react";

import { RichText } from "web/react/emo/rich-text";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";

import { ImageContainer } from "web/react/emo/image-container";

import { useEditorialAnalytics } from "web/react/hooks/use-editorial-analytics";
import { gettext } from "web/script/modules/django-i18n";
import { EditorialIntroSerializer } from "web/types/serializers";
import * as styles from "./intro-block.css";

interface IntroBlockProps extends EditorialIntroSerializer {
    isSponsored: boolean;
    editorialLabel: string;
    franchise: string;
    tags: string[];
    gender: "womenswear" | "menswear" | "mixed";
    position: number;
}

export function IntroBlock({
    image_url: imageUrl,
    image_credit: imageCredit,
    isSponsored,
    body,
    editorialLabel,
    franchise,
    gender,
    tags,
    position,
}: IntroBlockProps): React.ReactElement {
    const { containerRef } = useEditorialAnalytics({
        label: "intro_block",
        editorialLabel,
        franchise,
        tags,
        position,
        gender,
        isSponsored,
    });

    // This guide for the fashion-fluent has been created as part of a paid partnership, with all products hand-picked by our editorial team. We make a commission on the sale of these products.
    const sponsoredDisclaimer = gettext("editorial.sponsored_disclaimer");
    // All products are hand-picked by our editorial team. We make a commission on the sale of these products.
    const standardDisclaimer = gettext("editorial.standard_disclaimer");

    return (
        <section className={styles.container}>
            <VStack spacing="xm">
                {imageUrl && (
                    <div ref={containerRef}>
                        <ImageContainer imageSrc={imageUrl} imageCredit={imageCredit} />
                    </div>
                )}
                <div className={styles.introText}>
                    <Text
                        dataTestId="disclaimer"
                        className={styles.sponsored}
                        textStyle="caption-3"
                        upperCase
                    >
                        {isSponsored ? sponsoredDisclaimer : standardDisclaimer}
                    </Text>
                    {body && (
                        <RichText className={styles.body} textStyle={{ sm: "body-s", md: "body" }}>
                            {body}
                        </RichText>
                    )}
                </div>
            </VStack>
        </section>
    );
}
